import { BADGE_STATUS_COLOR } from './types';

const stylesStatus = {
  display: 'inline-block',
  borderRadius: 1,
  border: 1,
  p: 0.5,
  fontWeight: 'fontWeightMedium',
  fontSize: 'bodySM.fontSize',
  '.MuiSvgIcon-root': {
    verticalAlign: 'middle',
  },
};

export const stylesStatusTextOnly = (textOnly: boolean) => {
  if (textOnly) {
    return {
      bgcolor: 'initial',
      p: 0,
      fontWeight: 'fontWeightRegular',
    };
  }
  return {};
};

export const stylesStatusColor = (statusColor: BADGE_STATUS_COLOR) => {
  switch (statusColor) {
    case BADGE_STATUS_COLOR.LOW:
      return {
        ...stylesStatus,
        color: 'success.dark',
        bgcolor: 'success.lighter',
        borderColor: 'success.light',
      };
    case BADGE_STATUS_COLOR.MEDIUM:
      return {
        ...stylesStatus,
        color: 'warning.dark',
        bgcolor: 'warning.lighter',
        borderColor: 'warning.light',
      };
    case BADGE_STATUS_COLOR.HIGH:
      return {
        ...stylesStatus,
        color: 'error.dark',
        bgcolor: 'error.lighter',
        borderColor: 'error.light',
      };
    default:
      return {
        ...stylesStatus,
        color: 'text.primary',
        bgcolor: 'grey.100',
      };
  }
};
